<template>
  <div>
    <v-toolbar color="background darken-1" flat>
      <v-toolbar-title v-bind:class="moveTitleClassObject"
        >Items Ejecutados
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text dark mediun color="secondary" @click="loadData()">
        <v-icon dark>mdi-refresh</v-icon>
        Actualizar
      </v-btn>
      <excell
        :items="items"
        :headers="xlsxHeaders"
        :fieldValues="xlsxFields"
      ></excell>
    </v-toolbar>
    <v-container fluid grid-list-lg>
      <v-row>
        <v-col no-gutters>
          <resume :isLoading="loading" :agg="agg"></resume>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <ejecutados-table :items="items" :loading="loading" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { postDashboard } from "@/api/private/dashboard";
import Excell from "@/components/Excell";
import EjecutadosTable from "./components/EjecutadosTable";
import Resume from "@/components/Resume";
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  name: "Ejecutados",
  components: {
    Excell,
    Resume,
    EjecutadosTable
  },
  data() {
    return {
      tab: null,
      snackbar: false,
      snackbarText: "",
      loading: false,
      loadingMoreBtn: false,
      from: 0,
      agg: [],
      aggOtros: [],
      items: [],
      otrosItems: [],
      dialog: false,
      xlsxHeaders: [
        "AÑO",
        "PERIODO",
        "CODIGO PROCESO",
        "PROVEEDOR ADJUDICADO",
        "CONTRATANTE",
        "PROCEDIMIMIENTO",
        "TIPO COMPRA",
        "OBJETO DEL PROCESO",
        "DESCRIPCION DEL ITEM",
        "CPC NIVEL 5",
        "CPC NIVEL 9",
        "PROVINCIA",
        "CANTON",
        "CANTIDAD",
        "MEDIDA",
        "VALOR UNITARIO",
        "TOTAL"
      ],
      xlsxFields: [
        "ano",
        "periodo",
        "codigo_proceso",
        "nombre_proveedor",
        "nombre_entidad",
        "procedimiento",
        "pac_tipo",
        "objeto_proceso",
        "descripcion",
        "descripcion_cpc",
        "descripcion_cpc_full",
        "provincia_entidad",
        "canton_entidad",
        "pac_cantidad",
        "pac_medida",
        "pac_costo_unitario",
        "pac_total"
      ],
      logger: {}
    };
  },
  computed: {
    ...mapGetters(["filters"]),
    drawer() {
      return !this.$store.getters.dashboardDrawer;
    },
    showMoreItems() {
      return this.otrosItems.length > 0 && !this.loading ? true : false;
    },

    moveTitleClassObject: function() {
      return {
        "ml-12": !this.$store.getters.dashboardDrawer
      };
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: function() {
        this.loadData();
      }
    }
  },
  methods: {
    elasticResultPreprocessor: function(body) {
      return body.hits.hits.map(item =>
        Object.assign({}, item._source, { highlight: item.highlight })
      );
    },
    loadMore: async function() {
      this.from = this.from + 1000;
      this.loadingMoreBtn = true;
      await this.loadData(this.from);
      this.loadingMoreBtn = false;
    },
    loadData: async function(from = 0) {
      let userInfo = await this.$Amplify.Auth.currentUserInfo();
      if (Object.entries(userInfo).length === 0) {
        this.$Amplify.Auth.signOut()
          .then(() => {
            this.logger.info("signout success");
            return AmplifyEventBus.$emit("authState", "signedOut");
          })
          .catch(e => console.log(e));
      } else {
        try {
          //let user = await this.$Amplify.Auth.currentAuthenticatedUser();
          //console.log(user);
          //console.log(userInfo);

          if (!this.loadingMoreBtn) {
            this.items = [];
            this.otrosItems = [];
            this.from = 0;
          }
          this.loading = true;
          try {
            let { agg, aggOtros, items } = await postDashboard(from);
            this.agg = agg;
            this.aggOtros = aggOtros ? aggOtros : [];

            if (!this.loadingMoreBtn) {
              this.items = this.elasticResultPreprocessor(items);
            }
          } catch (e) {
            console.log(e);
          } finally {
            this.loading = false;
          }
        } catch (e) {
          console.log(e);
          //this.$router.push("/auth");
          //this.$store.dispatch("setUser", null);
        }
      }
    }
  },
  mounted() {
    this.loadData();
    this.logger = new this.$Amplify.Logger(this.$options.name);
  }
};
</script>
